import styled from 'styled-components';
import {scrollbar, mobileMedia, dFlex, dFlexCenter} from '../../globalVariables/GlobalVariables';

export const container = styled.div`
    height: 100%;
    width: 100%;
    ${dFlex};
    flex-direction: column;
    min-height: 0;
    border-radius: var(--radius-xl);
    border: 1px solid var(--TA-color-border-subtle);
    overflow: hidden;
    background: var(--TA-color-bg-base);
    ${mobileMedia} {
        border-radius: 0;
        border: none;
        overflow: visible;
        margin-top: -30px;
    }
`;

export const contentArea = styled.div`
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    ${scrollbar}
    ${mobileMedia} {
        padding: 0;
        overflow-y: auto;
    }
`;

export const loadingState = styled.div`
    flex: 1;
    ${dFlexCenter};
    color: var(--TA-color-text-subtle);
    font-size: var(--font-size-body);
`;

export const dragOverlayCard = styled.div<{$isActive?: boolean}>`
    box-shadow: 0 8px 24px rgba(0,0,0,0.18);
    border-radius: var(--radius-xs);
    opacity: ${({$isActive}) => $isActive ? 0.95 : 1};
`;

export const toolbarDivider = styled.hr`
    width: 1px;
    height: 20px;
    background: var(--TA-color-border-subtle);
    flex-shrink: 0;
    border: none;
    margin: 0;
`;
